<template>
  <div v-if="isModalFilter" class="modal_thematic_card">
    <div id="backdrop" class="fade in modal-backdrop" @click="closeModal"></div>
    <div role="dialog" aria-modal="true" class="modal_thematic_card__inner" :aria-labelledby="dataSetting?.title">
      <div ref="firstFocusModal" class="firstfocusmodal" tabindex="0"></div>
      <button
        type="button"
        class="close-modal-filter"
        :title="ThematicCardTranslate.popin.close_text"
        @click="closeModal()"
        >
          <i class="icon-close" aria-hidden="true"><span class="sr-only">{{ ThematicCardTranslate.popin.close_text }}</span></i>
        </button>
      <div class="card-thematic" :style="{ 'max-height': modalHeight + 'px' }">
        <div class="card-content">
          <div class="modal-card-header">
            <h2 class="card-title">{{ dataSetting?.title }}</h2>
            <p class="card-tag"><i class="icon icon-map" aria-hidden="true"></i>{{ dataSetting?.field_tc_popin_title }}</p>
            <p v-if="dataSetting?.changed" class="card-maj">{{ ThematicCardTranslate.popin.maj_text }} {{ dataSetting?.changed }}</p>
          </div>
          <div class="modal-card-body">
            <div v-if="dataSetting?.field_tc_popin_text" class="card-edito">
              <div class="card-edito__content">
                <div class="text">
                  <div v-html="$sanitize(dataSetting?.field_tc_popin_text)" class="wysiwyg" />
                  <div v-if="showAll"
                        v-show="dataSetting?.field_tc_popin_text_show_more"
                        v-html="$sanitize(dataSetting?.field_tc_popin_text_show_more)" class="wysiwyg"/>
                </div>
                <div v-if="dataSetting?.field_tc_popin_text_show_more" class="voir-plus">
                  <a href="#?" @click.prevent="showMore()" >
                    <span v-if="showAll">{{ ThematicCardTranslate.popin.show_moins_text }}</span>
                    <span v-else>{{ ThematicCardTranslate.popin.show_plus_text }}</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="filter-thematic-card_modal">
              <template v-if="dataApi && dataApi.length > 0">
                <h3 class="filter-title"><i class="icon-filter" aria-hidden="true"></i>{{ ThematicCardTranslate.popin.filter_titre_text }}</h3>
                <div class="filter-location-form">
                  <div v-if="displayNoLocationSelected" class="filter-location-error-msg">
                    <i class="icon-danger" aria-hidden="true" />
                    {{ ThematicCardTranslate.popin.no_location_selected }}
                    <span class="close-error-msg" @click.prevent="displayNoLocationSelected = false">
                      <i class="icon-close-circle-solid" aria-hidden="true" />
                      <span class="sr-only">Fermer</span>
                    </span>
                  </div>
                  <WhereAutoCompletePopin
                    v-if="dataSetting.field_tc_where_activated"
                    :resetActionStatus="resetStatus"
                    :reset-where-status="resetWhere"
                    @clearWhereValue="(text) => { onWhereValue(text, true) }"
                    @locationInput="onLocationInput"
                    @whereValue="onWhereValue"
                  />
                </div>
                <div class="filter-list">
                  <ThematicCardModalFilter
                    v-for="(formFilterValuesElem, formFilterValuesIndex) in dataApi"
                    :key="formFilterValuesIndex"
                    :dataFilterForm="formFilterValuesElem"
                    @changeFilters="onChangeFilters"
                  />
                </div>
              </template>
              <div class="wrp-button">
                <div class="button_elem">
                  <button class="element-action" type="button" @click="closeModal()">
                    {{ ThematicCardTranslate.popin.acceder_la_text }}
                    {{ ThematicCardTranslate.popin[modeType] }}
                    <span>( {{ wordingResults }} )</span>
                  </button>
                </div>
                <div class="button_elem">
                  <button type="button" :aria-disabled="noUserSelection" :disabled="noUserSelection" class="element-reset" @click="onResetFilters()">
                    {{ ThematicCardTranslate.popin.tout_effacer_text }}
                  </button>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <div ref="lastFocusModal" class="lastfocusmodal" tabindex="0"></div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  inject,
  onMounted,
  onUnmounted,
  ref,
  watch,
  nextTick,
} from 'vue';
import { debounce } from '@/helpers';

import { ThematicCardTranslate } from '@/services/translate';
import MobileDetectionHook from '@/hooks/mobileDetection.hook';

import ThematicCardModalFilter from '@/components/thematicCard/ThematicCardModalFilter.component.vue';
import WhereAutoCompletePopin from '@/components/thematicCard/WhereAutoCompletePopin.component.vue';

export default {
  components: {
    ThematicCardModalFilter,
    WhereAutoCompletePopin,
  },
  props: {
    dataApi: {
      type: Object,
      default: null,
    },
    dataApiNbResult: {
      type: Number,
      default: 0,
    },
    dataSetting: {
      type: Object,
      default: null,
    },
    isModalFilter: {
      type: Boolean,
      default: true,
    },
    modeType: {
      type: String,
      default: '',
    },
    isActive: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    'resetFilters',
    'newQueryFilter',
    'closeModalClick',
  ],
  setup(props, { emit }) {
    const { isScreenMdMin: isMobile } = MobileDetectionHook();
    const displayNoLocationSelected = ref(false);
    const locationInputValue = ref('');
    const refPopup = ref(null);
    const resetStatus = ref(false);
    const resetWhere = ref(false);
    const showAll = ref(false);
    const whereValue = ref('vide');
    const filterQuery = inject('filterQuery');
    const noUserSelection = computed(() => Object.keys(filterQuery.value).length === 0 && whereValue.value === 'vide');
    const isRestModalFilter = inject('isRestModalFilter');
    const personalizedZoom = inject('personalizedZoom');
    const markerAroundMe = inject('markerAroundMe');
    const wordingResults = computed(() => (props.dataApiNbResult < 2 ? `${props.dataApiNbResult} résultat` : `${props.dataApiNbResult} résultats`));
    const firstFocusModal = ref(null);
    const lastFocusModal = ref(null);
    const lastFocusedElement = ref(null);

    const keyHandler = (e) => {
      if (e.code === 'Escape') {
        emit('closeModalClick');
      }
      if (e.code === 'Tab' && document.activeElement === lastFocusModal.value) {
        firstFocusModal.value.focus();
      }
      if (e.shiftKey && e.code === 'Tab' && document.activeElement === firstFocusModal.value) {
        lastFocusModal.value.focus();
      }
    };

    // eslint-disable-next-line no-use-before-define
    watch(() => props.isModalFilter, updateModalAttributes);

    // Handle modal height
    const modalHeight = ref(300);
    const updateModalHeight = debounce(() => {
      modalHeight.value = isMobile.value ? window.innerHeight - 37 : window.innerHeight - 180;
    }, 100);

    function updateModalAttributes() {
      if (props.isModalFilter) {
        nextTick(() => {
          if (firstFocusModal.value) {
            firstFocusModal.value.focus();
            document.body.addEventListener('keydown', keyHandler);
          }
        }, { immediate: true });
      } else {
        document.body.removeEventListener('keydown', keyHandler);
      }
    }

    function showModalFilterOn() {
      lastFocusedElement.value = document.activeElement;
    }

    function closeModal() {
      if (locationInputValue.value !== '' && whereValue.value === 'vide') {
        displayNoLocationSelected.value = true;

        // eslint-disable-next-line no-use-before-define
        resetWhereValue();
      }
      if (lastFocusedElement.value) {
        lastFocusedElement.value.focus();
      }
      emit('closeModalClick');
    }

    function onChangeFilters(event) {
      // force to clean location search when there is text
      // but no selected location
      if (locationInputValue.value !== '' && whereValue.value === 'vide') {
        displayNoLocationSelected.value = true;

        // eslint-disable-next-line no-use-before-define
        resetWhereValue();
      } else {
        displayNoLocationSelected.value = false;
      }
      emit('changeFilters', event);
    }

    function onLocationInput(event) {
      displayNoLocationSelected.value = false;
      locationInputValue.value = event;
      resetWhere.value = false;
    }

    function onResetFilters() {
      displayNoLocationSelected.value = false;
      isRestModalFilter.value = true;
      personalizedZoom.value = false;
      resetStatus.value = true;
      resetWhere.value = true;
      if (typeof markerAroundMe.value.remove === 'function') {
        markerAroundMe.value.remove();
      }
      // eslint-disable-next-line no-use-before-define
      resetWhereValue();
      emit('resetFilters', {}, '');
    }

    function onWhereValue(text, preventDisplayNoLocationSelected = false) {
      if (text === 'vide') {
        if (!preventDisplayNoLocationSelected) {
          displayNoLocationSelected.value = true;
        }
        // eslint-disable-next-line no-use-before-define
        resetWhereValue();
      } else {
        displayNoLocationSelected.value = false;
        resetWhere.value = false;
      }

      resetStatus.value = false;
      whereValue.value = text;

      emit('newQueryFilter', filterQuery.value, whereValue.value);
    }

    function resetWhereValue() {
      locationInputValue.value = '';
      resetWhere.value = true;
      whereValue.value = 'vide';
    }

    function showMore() {
      showAll.value = !showAll.value;
    }

    onMounted(() => {
      updateModalHeight();
      updateModalAttributes();
      window.addEventListener('resize', updateModalHeight);
      showModalFilterOn();
    });

    onUnmounted(() => {
      updateModalAttributes();
      showModalFilterOn();
      window.removeEventListener('resize', updateModalHeight);
    });

    return {
      ThematicCardTranslate,
      displayNoLocationSelected,
      filterQuery,
      isRestModalFilter,
      closeModal,
      modalHeight,
      onChangeFilters,
      onLocationInput,
      onResetFilters,
      onWhereValue,
      personalizedZoom,
      refPopup,
      resetStatus,
      resetWhere,
      showAll,
      showMore,
      whereValue,
      wordingResults,
      markerAroundMe,
      noUserSelection,
      firstFocusModal,
      lastFocusModal,
      lastFocusedElement,
      showModalFilterOn,
    };
  },
};
</script>
